import type { QuerySpec } from '@helios/powersync-client-core';

/**
 * List all intake form definitions, ordered by version desc.
 */
export function qIntakeFormDefinitions(): QuerySpec<[]> {
  return {
    key: ['intake-forms', 'definitions'] as const,
    sql: `SELECT * FROM intake_form_definitions ORDER BY version DESC`,
    params: [],
    watch: ['intake_form_definitions'],
  };
}

/**
 * Fetch a single intake form definition by ID.
 */
export function qIntakeFormDefinitionById(id: string): QuerySpec<[string]> {
  return {
    key: ['intake-forms', 'definition', id] as const,
    sql: `SELECT * FROM intake_form_definitions WHERE id = ?`,
    params: [id],
    watch: ['intake_form_definitions'],
  };
}

/**
 * Fetch the latest published intake form definition.
 */
export function qLatestPublishedIntakeFormDefinition(): QuerySpec<[]> {
  return {
    key: ['intake-forms', 'latest-published'] as const,
    sql: `SELECT * FROM intake_form_definitions
          WHERE status = 'published'
          ORDER BY version DESC
          LIMIT 1`,
    params: [],
    watch: ['intake_form_definitions'],
  };
}
